export const listGestionnairesAttributes = ` 
collection {
 id
 firstName
 lastName
 }
`
